import { render, staticRenderFns } from "./property-table-item.vue?vue&type=template&id=3f75299a&"
import script from "./property-table-item.vue?vue&type=script&lang=js&"
export * from "./property-table-item.vue?vue&type=script&lang=js&"
import style0 from "./property-table-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports